// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2a1931b4","247":"3b21bba4","268":"59c84a36","284":"b748a1f0","312":"50d6b61c","627":"28f0e77b","738":"ecd733ef","768":"93390723","834":"52eb6c84","923":"30d0f7ac","938":"1ae5ef57","950":"3a138509"}[chunkId] + ".chunk.js";
};